// // src/services/http.ts
// import axios from "axios";

// /**
//  * Base d’API (Vue CLI):
//  *   .env.development → VUE_APP_API_BASE=http://10.0.0.47:5001
//  *   .env.production  → VUE_APP_API_BASE=https://babacode.ca
//  *
//  * ⚠️ NE PAS terminer par /api dans l’env — on l’ajoute ici.
//  */
// const RUNTIME_BASE =
//   (window as any).__API_BASE__ ||
//   (process.env as any)?.VUE_APP_API_BASE ||
//   window.location.origin;

// export const API_BASE = String(RUNTIME_BASE || "").replace(/\/+$/, ""); // ex: http://10.0.0.47:5001
// export const API_URL  = `${API_BASE}/api`;                              // ex: http://10.0.0.47:5001/api

// /** Construit une URL d’API sûre: apiUrl("contact/threads") -> .../api/contact/threads */
// export const apiUrl = (path: string) =>
//   `${API_URL}/${String(path || "").replace(/^\/+/, "")}`;

// /**
//  * Instance Axios standardisée
//  * - baseURL = <API_URL>
//  * - withCredentials = true (cookies si besoin)
//  * - Bearer auto si localStorage.auth_token
//  */
// const http = axios.create({
//   baseURL: API_URL,
//   withCredentials: true,
// });

// // Ajout automatique du Bearer token si présent
// http.interceptors.request.use((config) => {
//   try {
//     const token = localStorage.getItem("auth_token");
//     if (token) {
//       config.headers = config.headers || {};
//       (config.headers as any).Authorization = `Bearer ${token}`;
//     }
//   } catch {
//     // ignore
//   }
//   return config;
// });

// export default http;
// src/api/http.ts

// import axios, { AxiosInstance } from "axios";

// declare global {
//   interface Window {
//     __API_BASE__?: string;
//   }
// }

// /**
//  * ⚠️ Ne mets PAS /api dans VITE_API_BASE / VUE_APP_API_BASE.
//  * Exemples:
//  *  - dev : http://127.0.0.1:5001
//  *  - prod: https://babacode.ca
//  */
// const RUNTIME_BASE =
//   (typeof window !== "undefined" && (window as any).__API_BASE__) ||
//   (import.meta as any)?.env?.VITE_API_BASE ||
//   (process.env as any)?.VUE_APP_API_BASE ||
//   "";

// // Helpers
// const stripSlash = (s: string) => String(s || "").replace(/\/+$/, "");
// const hostNoWww = (u: string) => {
//   try {
//     return new URL(u).host.replace(/^www\./i, "");
//   } catch {
//     return "";
//   }
// };

// const PAGE_ORIGIN = stripSlash(window.location.origin);
// const CONFIGURED = stripSlash(RUNTIME_BASE);

// // Même site si : pas de base config, ou host identique en ignorant "www."
// const SAME_SITE = !CONFIGURED || hostNoWww(CONFIGURED) === hostNoWww(PAGE_ORIGIN);

// // Base API:
// // - même site → utiliser '/api' (relative) → pas de CORS
// // - sinon     → utiliser 'https://…/api'
// export const API_BASE: string = SAME_SITE ? PAGE_ORIGIN : CONFIGURED;
// export const API_URL: string = SAME_SITE ? "/api" : `${API_BASE}/api`;

// /** Construit une URL d’API sûre: apiUrl("contact/threads") -> .../api/contact/threads */
// export const apiUrl = (path: string): string =>
//   `${API_URL}/${String(path || "").replace(/^\/+/, "")}`;

// const http: AxiosInstance = axios.create({
//   baseURL: API_URL,      // peut être '/api' (relative) ou 'https://.../api'
//   withCredentials: true,
// });

// // Ajout automatique du Bearer token si présent
// http.interceptors.request.use((config) => {
//   try {
//     const token = localStorage.getItem("auth_token");
//     if (token) {
//       // Axios v1: headers peut être AxiosHeaders (avec .set) ou un objet simple
//       const h = config.headers as any;
//       if (h && typeof h.set === "function") {
//         h.set("Authorization", `Bearer ${token}`);
//       } else {
//         const merged = { ...(config.headers as Record<string, unknown> | undefined), Authorization: `Bearer ${token}` };
//         config.headers = merged as any; // cast pour rester compatible avec AxiosRequestHeaders
//       }
//     }
//   } catch {
//     // ignore
//   }
//   return config;
// });

// export default http;

import axios, { AxiosInstance } from "axios";

// 1. Nettoyage de la base URL
const getBaseURL = (): string => {
  const rawBase =
    (typeof window !== "undefined" && (window as any).__API_BASE__) ||
    process.env.VUE_APP_API_BASE ||
    "";

  // On retire les slashs de fin ET le "/api" s'il est déjà présent dans la config
  const cleanBase = rawBase.replace(/\/+$/, "").replace(/\/api$/, "");

  // Si on est sur le même domaine, on utilise le chemin relatif
  // Sinon, on construit l'URL absolue vers l'API
  if (!cleanBase || cleanBase === window.location.origin) {
    return "/api";
  }
  return `${cleanBase}/api`;
};

export const API_URL = getBaseURL();

/**
 * apiUrl ne sert QUE pour les éléments HTML (<img>, <a>, etc.)
 * Ne jamais l'utiliser à l'intérieur d'un appel http.get()
 */
export const apiUrl = (path: string): string => {
  const cleanPath = String(path || "").replace(/^\/+/, "");
  return `${API_URL}/${cleanPath}`;
};

// 2. Instance Axios unique
const http: AxiosInstance = axios.create({
  baseURL: API_URL, // Axios s'occupe de préfixer tous les appels
  withCredentials: true,
});

// 3. Intercepteur de sécurité (Bearer Token)
http.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem("auth_token");
    if (token && config.headers) {
      if (typeof (config.headers as any).set === "function") {
        (config.headers as any).set("Authorization", `Bearer ${token}`);
      } else {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
    }
  } catch (e) {
    // Silencieux en cas d'erreur localStorage
  }
  return config;
});

export default http;